import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebook,
  faGithub,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import "./Socials.css";

function Socials() {
  const [showEmail, setShowEmail] = useState(false);

  const gitHubURL = "https://www.github.com/PrzemoProgrammer";
  const linkedInURL = "https://www.linkedin.com/in/przemek-murawski-muran/";
  const instagramURL = "https://www.instagram.com/muran_98";
  const facebookURL = "https://www.facebook.com/przemek.murawski.7";

  const toggleEmail = () => {
    setShowEmail(!showEmail);
  };

  return (
    <section className="socials-container" id="socials">
      <div className="contactAndMedia">
        <div className="social-icons">
          <a href="#email" onClick={toggleEmail}>
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
          <a href={gitHubURL} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a href={linkedInURL} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a href={instagramURL} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a href={facebookURL} target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>
        {showEmail && (
          <div className="email-address">
            <h2 className="email">
              przemek.murawski.developer@gmail.com
              <br />
            </h2>
          </div>
        )}
      </div>
    </section>
  );
}

export default Socials;
